import React, { useState, useCallback, useEffect } from "react";
import moment from "moment";

// Accepts timeConstraint as hours | minutes
const getTime = (timeConstraint) => {
  return Array(timeConstraint === "hours" ? 24 : 60)
    .fill({})
    .map((_, index) => ({
      [timeConstraint === "hours" ? "hour" : "min"]: index.toLocaleString(
        "en-Us",
        {
          minimumIntegerDigits: 2,
          useGrouping: false,
        }
      ),
    }));
};

const DateSchedulingDropDown = ({
  type,
  dropDownData,
  timeSelection,
  format,
  day,
  toOrFrom,
  setData,
}) => {
  const filterDropDownData = useCallback(() => {
    return dropDownData
      ?.filter((d) => d.day === day)
      .map((item) => item[toOrFrom])[0];
  }, [day, dropDownData, toOrFrom]);

  const mom = moment(filterDropDownData()).format(format);

  const [isDate, setIsDate] = useState(mom);

  useEffect(() => {
    if (isDate !== mom) setIsDate(mom);
  }, [filterDropDownData, format, mom]);

  const onChangeHandler = (e) => {
    setIsDate(e.target.value);
    setData(e.target.value);
  };

  return (
    <select
      className={
        type === "primary"
          ? "form-select bg-berylline"
          : "form-select  field-white"
      }
      onChange={onChangeHandler}
      value={isDate}
    >
      {timeSelection === "hour"
        ? getTime("hours").map(({ hour }, key) => {
            return (
              <option key={key} value={hour}>
                {hour}
              </option>
            );
          })
        : timeSelection === "min"
        ? getTime("minutes").map(({ min }, key) => {
            return (
              <option key={key} value={min}>
                {min}
              </option>
            );
          })
        : ""}
    </select>
  );
};

export default DateSchedulingDropDown;
